import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n'
import {downloadDocument} from '../../util/util'
import actionTypes from '../../constants/actions/importarLineasPedidosExcel/importarLineasPedidosExcel'
import {submitImportarLineasPedidosExcelSuccess} from '../../actions/importarLineasPedidosExcel/importarLineasPedidosExcel'
import {openModal, closeModal, openSimpleModal, openMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import getImportarLineasPedidosExcel from '../../services/importarLineasPedidosExcel/getImportarLineasPedidosExcel'
import getDescargarPlantillaExcelLineasPedidosExcel from '../../services/importarLineasPedidosExcel/getDescargarPlantillaExcelLineasPedidosExcel'

export function * submitImportarLineasPedidosExcel ({value}) {
  try {
    let auth = yield select(state => state.auth)
    const listCargaIndex = yield call(getImportarLineasPedidosExcel, value, auth.token)    
    yield put(submitImportarLineasPedidosExcelSuccess(listCargaIndex))
  } catch (error) {
    console.log(error)
  } finally {
    /*yield put(commonActions.hideLoader())*/
  }
}
export function * watchSubmitImportarLineasPedidosExcel () {
  yield takeLatest(actionTypes.SUBMIT_IMPORTAR_LINEAS_PEDIDOS_EXCEL, submitImportarLineasPedidosExcel)
}

export function * descargarPlantillaExcelLineasPedidosExcel () {
  try {
    const archivoExcel = yield call(getDescargarPlantillaExcelLineasPedidosExcel, null)
    let href = 'data:application/csv;base64,' + encodeURIComponent(archivoExcel.xls)
    let name = i18n.t('IMPORTAR_LINEAS_PEDIDOS_EXCEL.EJEMPLO_EXCEL_LINEAS_PEDIDOS') + ".xlsx"
    downloadDocument(href, name)
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchDescargarPlantillaExcelLineasPedidosExcel () {
  yield takeLatest(actionTypes.DESCARGAR_PLANTILLA_EXCEL_LINEAS_PEDIDOS_EXCEL, descargarPlantillaExcelLineasPedidosExcel)
}